import React from 'react'
import { useQuery } from '@apollo/client'
import { Table, Segment } from 'semantic-ui-react'
import moment from 'moment'
import { LOAD_AGENDA_STATS_QUERY } from '../../../graphql/admin'
import LoadingSpinner from '../../LoadingSpinner'

const formatDuration = (ms) => {
  if (ms == null) return '—'
  if (ms < 1000) return `${Math.round(ms)}ms`
  const seconds = ms / 1000
  if (seconds < 60) return `${seconds.toFixed(1)}s`
  const minutes = Math.floor(seconds / 60)
  return `${minutes}m ${Math.round(seconds % 60)}s`
}

const AgendaStats = () => {
  const { loading, data, error } = useQuery(LOAD_AGENDA_STATS_QUERY)

  if (loading) return <LoadingSpinner />
  if (error) return <div>Error loading agenda stats: {error.message}</div>

  const stats = data?.adminPortal?.agendaStats || []

  return (
    <Segment style={{ padding: '2.5rem', width: '100%' }}>
      <h2>Agenda Job Stats</h2>
      <Table celled striped>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Job Name</Table.HeaderCell>
            <Table.HeaderCell>Succeeded</Table.HeaderCell>
            <Table.HeaderCell>Failed</Table.HeaderCell>
            <Table.HeaderCell>Total</Table.HeaderCell>
            <Table.HeaderCell>Queued</Table.HeaderCell>
            <Table.HeaderCell>Avg Run Time (24h)</Table.HeaderCell>
            <Table.HeaderCell>Last Succeeded At</Table.HeaderCell>
            <Table.HeaderCell>Last Failed At</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {stats.map((stat) => (
            <Table.Row key={stat.name}>
              <Table.Cell>{stat.name}</Table.Cell>
              <Table.Cell>{stat.succeeded}</Table.Cell>
              <Table.Cell error={stat.failed > 0}>{stat.failed}</Table.Cell>
              <Table.Cell>{stat.total}</Table.Cell>
              <Table.Cell warning={stat.queued > 0}>{stat.queued}</Table.Cell>
              <Table.Cell>{formatDuration(stat.avgDurationMs)}</Table.Cell>
              <Table.Cell>
                {stat.lastSucceededAt
                  ? moment(parseInt(stat.lastSucceededAt)).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : 'Never'}
              </Table.Cell>
              <Table.Cell error>
                {stat.lastFailedAt
                  ? moment(parseInt(stat.lastFailedAt)).format(
                      'YYYY-MM-DD HH:mm:ss'
                    )
                  : 'Never'}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Segment>
  )
}

export default AgendaStats

